import { StateCreator } from 'zustand';
import { ILaunchdarklyFlagData, TLaunchdarklyFlags } from './launchdarklyFlags.interface';

export const launchdarklyFlagDataSlice: StateCreator<ILaunchdarklyFlagData> = (set) => ({
  ldFlags: {},
  setLdFlags(data: TLaunchdarklyFlags | null) {
    set(() => ({ ldFlags: data }));
  },
});
